import vi_VN from "common/translations/vi_VN";
// import en_US from "common/translations/en_US";

let i18nResource = {
  vi_VN,
};

export default i18nResource;
